import { Stack, Typography } from '@mui/material';

import { ReferralControl } from './ui/referral-control';
import { ReferralListView } from './ui/referral-list';

const ReferalDescription = () => {
  return (
    <Stack direction={{ xs: 'column', md: 'row' }} width="100%" gap={{ xs: 3, md: 2 }} mb={{ xs: 8, md: 21.5 }}>
      <Stack gap={1} flex={1} px={{ xs: 0, md: 1 }}>
        <Typography variant="body2" className="secondary">
          C.P.A. (Cost Per Acquisition) in Tap-2-Mine rewards partners with a 10% commission for every new mining rig
          license sold through their referral or agent efforts.
        </Typography>
        <Typography variant="body2" className="secondary">
          The C.P.A. program ensures that rewards are paid only to real, verified users who successfully join the
          ecosystem.
        </Typography>
        <Typography variant="body2" className="secondary">
          Every payout is fully transparent and recorded on-chain for security and auditability.
        </Typography>
      </Stack>

      <Stack gap={1} flex={1} px={{ xs: 0, md: 2.5 }}>
        <Typography variant="body2" className="secondary">
          C.P.A. partners can track their total earned rewards in a dedicated dashboard within the portal.
        </Typography>
        <Typography variant="body2" className="secondary">
          When ready, the partner submits a withdrawal request directly from their dashboard.
        </Typography>
        <Typography variant="body2" className="secondary">
          This system promotes ethical practices and ensures a sustainable, performance-based reward model that supports
          CratD2C’s growth.
        </Typography>
      </Stack>
    </Stack>
  );
};

export const Tap2MineReferralProgram = () => {
  return (
    <>
      <Typography variant="h4" className="secondary" mb={5.7}>
        Referral Program (CPA)
      </Typography>

      <Stack display="flex" direction={{ xs: 'column', md: 'row' }} width="100%" alignItems="stretch" gap={2} mb={4}>
        <ReferralControl />
        <ReferralListView />
      </Stack>

      <ReferalDescription />
    </>
  );
};
